module.exports = __webpack_public_path__ + "media/images/fitness-first-mark-890a7c60e7930fb616dac3a56caa3f85.svg";